'use strict';

var React = require('react');
var bodyScrollLock = require('body-scroll-lock');

var useScrollLock = function (shouldLock, options) {
    if (shouldLock === void 0) { shouldLock = true; }
    var scrollLockRef = React.useRef(null);
    React.useEffect(function () {
        if (scrollLockRef.current && shouldLock) {
            var ref_1 = scrollLockRef.current;
            bodyScrollLock.disableBodyScroll(ref_1, options);
            return function () { return bodyScrollLock.enableBodyScroll(ref_1); };
        }
        return function () { };
    }, [shouldLock, options]);
    return scrollLockRef;
};

exports.useScrollLock = useScrollLock;
//# sourceMappingURL=useScrollLock-3e2e9f39.js.map
